<template>
    <div>
        <ui-modal v-if="isOpen" ref="editContactModal" class="contact-modal" :title="contact.id > 0 ? 'Edit Contact' : 'New Contact'" @hide="reset" dismiss-on="close-button esc">
            <div class="container-fluid" style="padding: 0; margin-top: 1rem;">
                <div class="row">
                    <div class="col-6">
                        <ui-select-proxy
                            label="Title"
                            :options="ContactTitles"
                            v-model="contact.title"
                            @input="unsetEmpty"
                        ></ui-select-proxy>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <ui-textbox label="First Name" v-model="contact.first_name"></ui-textbox>
                    </div>
                    <div class="col-6">
                        <ui-textbox label="Last Name" v-model="contact.last_name"></ui-textbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <ui-textbox label="Company Name" v-model="contact.company_name"></ui-textbox>
                    </div>
                </div>

                <div class="row" style="margin-top: 1rem;">
                    <div class="col-6">
                        <referral-source-picker
                            label="Referral Source" 
                            v-model="contact.referral_source"
                            :invalid="hasInvalidReferralSource"
                        ></referral-source-picker>
                    </div>
                    <div class="col-6">
                        <ui-select-proxy
                            label="Contact Type"
                            :options="ContactTypeList"
                            v-model="contact.type"
                            :invalid="hasInvalidType"
                        ></ui-select-proxy>
                    </div>
                </div>

                <!-- Contact Details !-->
                <div class="row" style="margin-top: 1rem;">
                    <div class="col">
                        <div class="meta-container">
                            <h5>Contact Details</h5>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <ui-textbox label="Email" v-model="contact.email"></ui-textbox>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6">
                        <ui-textbox label="Primary Telephone" v-model="contact.primary_telephone"></ui-textbox>
                    </div>
                    <div class="col-6">
                        <ui-textbox label="Alternate Telephone" v-model="contact.alternate_telephone"></ui-textbox>
                    </div>
                </div>

                <!-- Marketing Details !-->
                <div class="row">
                    <div class="col">
                        <div class="meta-container">
                            <h6 style="font-weight: normal;">Marketing Preferences &amp; Consent</h6>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <!-- Marketing Opt-In !-->
                    <div class="col">
                        <ui-switch 
                        label="Telephone"
                         v-model="contact.telephone_marketing" 
                         style="margin-bottom: 0; z-index:2;"
                        ></ui-switch>
                    </div>
                    <div class="col">
                        <ui-switch 
                        label="Email"
                         v-model="contact.email_marketing" 
                         style="margin-bottom: 0; z-index:2;"
                        ></ui-switch>
                    </div>

                    <div class="col">
                        <ui-switch 
                        label="SMS"
                         v-model="contact.sms_marketing" 
                         style="margin-bottom: 0; z-index:2;"
                        ></ui-switch>
                    </div>
                </div>
            </div>

                <!-- Address !-->
                <div class="row" style="margin-top: 1rem;">
                    <div class="col">
                        <div class="meta-container">
                            <h5>Address</h5>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <address-selector label="" v-model="addressProxy"></address-selector>
                    </div>
                </div>

               <!-- Other Details !-->
                <div class="row" style="margin-top: 1rem;">
                    <div class="col">
                        <div class="meta-container">
                            <h5>Other Details</h5>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6">
                        <ui-textbox label="VAT Number" v-model="contact.vat_registration_number"></ui-textbox>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6">
                        <keen-expense-category-selector
                            label="Default Expense Category"
                            v-model="contact.default_expense_account"
                            clearable
                        ></keen-expense-category-selector>
                    </div>
                    <div class="col-6">
                        <ui-tax-rate-selector
                            label="Default Expense Tax Rate"
                            v-model="contact.default_expense_tax_rate"
                            clearable
                        ></ui-tax-rate-selector>
                    </div>
                </div>

            <div slot="footer" style="width: 100%; text-align: right;">
                <ui-progress-circular v-show="isLoading" style="float:left;"></ui-progress-circular>
                <button :disabled="isLoading" class="btn btn-primary" @click="save">Save</button>
            </div>
        </ui-modal>

        <!-- Duplicates !-->
        <similar-contact-modal
            ref="duplicates"
        ></similar-contact-modal>
    </div>
</template>

<script>
    import { ContactSchema, ContactTypeList, ContactTitles, ContactTypes, ReferralSourceResource } from '../../classes/Api/Contact.js';
    import AddressSelector from './controls/KeenAddress'
    import ReferralSourcePicker from './controls/KeenReferralSourcePicker' 
    import KeenExpenseCategorySelector from './controls/KeenExpenseCategoryPicker'
    import { mapState, mapActions } from 'vuex';
    import SimilarContactModal from "../elements/SimilarContactModal";
    import {reportApiError} from "../../utils";
    import UiSelectProxy from "../../../ts/Elements/UiSelectProxy.vue"
    import UiTaxRateSelector from "../../../ts/Accounts/UiTaxRateSelector.vue"

    export default {
        components: {UiSelectProxy, SimilarContactModal, AddressSelector, ReferralSourcePicker, KeenExpenseCategorySelector, UiTaxRateSelector },
        data() {
            return {
                ContactTypeList,
                ContactTitles,
                contact: new ContactSchema(),
                isLoading: false,
                isCapsOn: false,
                isOpen: false,
            }
        },
        methods: {
            unsetEmpty(val) {
                if (typeof val === 'string' && val.length === 0) {
                    this.contact.title = null
                }
            },
            ...mapActions({ 'storeOrUpdate': 'contact/storeOrUpdate' }),
            reset() {
                this.isOpen = false

                this.isLoading = false

                this.contact = new ContactSchema();
            },
            open(defaults = {}) {
                this.reset()

                this.isOpen = true

                this.$nextTick(() => {
                    this.contact = Object.assign(
                        {}, this.contact, defaults, window.marque.ui.contact_attribute_defaults
                    );

                    if (this.contact.referral_source_id && !(this.contact.referral_source?.id)) {
                        ReferralSourceResource.find(this.contact.referral_source_id).then(response => {
                            this.$set(this.contact, 'referral_source', response.data)
                        })
                    }

                    if (this.contact.default_expense_account_id && !(this.contact.default_expense_account?.id)) {
                        ExpenseCategoryResource.find(this.contact.default_expense_account_id).then(response => {
                            this.$set(this.contact, 'default_expense_account', response.data)
                        })
                    }

                    setTimeout(() => {
                        this.$el.querySelector('.ui-modal__body').scrollTop = 0;
                    }, 75)

                    this.$refs['editContactModal'].open();
                })
            },
            save() {
                this.isLoading = true;

                let contact = Object.assign({}, this.contact);

                if (contact.referral_source) {
                    contact.referral_source_id = contact.referral_source.id;
                }

                if (contact.default_expense_account) {
                    contact.default_expense_account_id = contact.default_expense_account.id;
                } else {
                    contact.default_expense_account_id = null;
                }
                
                if (typeof this.contact.title !== 'string' && this.contact.title !== null) {
                    contact.title = contact.title.value;
                }

                if (typeof this.contact.type !== 'string' && this.contact.type !== null) {
                    contact.type = contact.type.value;
                }

                if (contact.id) {
                    this.finishSave(contact)
                    return
                }

                // If this is a new contact, we check whether the data given matches any existing contacts,
                // if it matches we offer them as suggestions, otherwise we just proceed with the save.
                this.$refs.duplicates.check(contact).then(contact => {
                    this.finishSave(contact)
                }).catch(e => {
                    reportApiError(e)
                }).finally(() => {
                    this.isLoading = false
                })
            },
            finishSave(contact) {
                this.storeOrUpdate(contact).then(contact => {
                    // @deprecated use saved
                    this.$emit('success', contact);
                    this.$emit('saved', contact);
                    this.isLoading = false;
                    this.$refs['editContactModal'].close();
                }).finally(() => {
                    this.isLoading = false;
                });
            },
            onSave(callback) {
                if (callback) {
                    this.$once('saved', callback)
                }
            }
        },
        computed: {
            ...mapState({ 'storeContact': state => state.contact.current }),
            hasInvalidType() {
                return !this.contact.type
            },
            hasInvalidReferralSource() {
                return !this.contact.referral_source || !this.contact.referral_source.id
            },
            addressProxy: {
                get() {
                    return {
                        address_1: this.contact.address_1,
                        address_2: this.contact.address_2,
                        address_3: this.contact.address_3,
                        town: this.contact.town,
                        county: this.contact.county,
                        post_code: this.contact.post_code,
                        country: this.contact.country,
                    }
                },
                set(address) {
                    this.contact.address_1 = address.address_1;
                    this.contact.address_2 = address.address_2;
                    this.contact.address_3 = address.address_3;
                    this.contact.town = address.town;
                    this.contact.county = address.county;
                    this.contact.post_code = address.post_code;
                    this.contact.country = address.country;
                }
            }
        }
    }
</script>